import React from 'react'

import s from '../NotFound.module.scss'

const Cup = () => {
	return (
		<g
			id={s.cup}
			data-name='Layer 7'
		>
			<polygon
				className={s.cls1}
				points='1173.69 748.21 1140.52 715.42 1195.79 647.35 1241.13 692.16 1173.69 748.21'
			/>
			<polygon
				className={s.cls8}
				points='1173.69 748.21 1140.52 715.42 1143.93 711.27 1177.81 744.75 1173.69 748.21'
			/>
			<polygon
				className={s.cls5}
				points='1194.68 731.46 1157.04 694.24 1183.8 661.7 1226.91 704.32 1194.68 731.46'
			/>
			<g className={s.cls10}>
				<path
					className={s.cls8}
					d='M1176.32,667.78h0a4.19,4.19,0,0,1,4.19,4.19v33.54a0,0,0,0,1,0,0h-8.38a0,0,0,0,1,0,0V672a4.19,4.19,0,0,1,4.19-4.19Z'
					transform='translate(822.53 -628.67) rotate(44.67)'
				/>
				<path
					className={s.cls8}
					d='M1172.73,709.7l23.58-23.85a4.19,4.19,0,0,1,5.92,0h0a4.19,4.19,0,0,1,0,5.92l-23.58,23.85Z'
				/>
				<path
					className={s.cls8}
					d='M1185.11,722.09l23.58-23.85a4.19,4.19,0,0,1,5.92,0h0a4.19,4.19,0,0,1,0,5.92L1191.06,728Z'
				/>
			</g>
			<path
				className={s.cls5}
				d='M1197.85,660.5h45.69a5.7,5.7,0,0,1,5.7,5.7v8.32a0,0,0,0,1,0,0h-57.09a0,0,0,0,1,0,0v-8.32A5.7,5.7,0,0,1,1197.85,660.5Z'
				transform='translate(829.53 -667.66) rotate(45)'
			/>
			<path
				className={s.cls8}
				d='M1191.49,664.74h53.94a5.25,5.25,0,0,1,5.25,5.25v4.79a0,0,0,0,1,0,0h-64.44a0,0,0,0,1,0,0V670a5.25,5.25,0,0,1,5.25-5.25Z'
				transform='translate(822.83 -663.17) rotate(44.67)'
			/>
		</g>
	)
}

export default Cup
